<ion-content>
  <app-slides-banner [banners]="futurePensioner?.banners" [bannerStyle]="bannerStyle" [loading]="loading"></app-slides-banner>
  <app-tab-navigation [tabs]="tabs" [navigation]="false" (tabSelected)="goTo($event)" [activeTab]="calendarTabUrl"></app-tab-navigation>

  <router-outlet></router-outlet>

  <app-footer></app-footer>
</ion-content>
